import type { CSSObject } from '@emotion/react'
import { Color, Typography } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lapidary'
import type { StyleProps } from './types'

export const container: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  ...modernWithFallback(
    [{ blockSize: '100vb' }, { blockSize: '100vh' }],
    'width: 1vi'
  ),
}

export const content = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,
  color: Color[theme].Text.Default,
  ...Typography.T500,
  boxSizing: 'border-box',
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  justifyContent: 'space-between',
})
